import { useEffect, useState } from 'react'
import { Row, Col, Input } from 'antd'

const NameInput = ({ onChange, value, disabled = false, error = null, readOnly = false }) => {
  const [name, setName] = useState({ familyName: '', givenName: '' })

  useEffect(() => {
    setName(value)
  }, [value])

  const onChangeFamilyName = (event) => {
    const newName = {
      ...name,
      familyName: event.target.value,
    }
    setName(newName)
    onChange(newName)
  }

  const onChangeGivenName = (event) => {
    const newName = {
      ...name,
      givenName: event.target.value,
    }
    setName(newName)
    onChange(newName)
  }
  return (
    <Row>
      <Col span={12}>
        <div style={{ paddingRight: 4 }}>
          <Input
            id="inputFamilyName"
            maxLength={100}
            placeholder="姓"
            value={name.familyName}
            onChange={onChangeFamilyName}
            style={{ paddingRight: 8 }}
            type="text"
            size="large"
            disabled={disabled}
            readOnly={readOnly}
            status={error ? 'error' : null}
          />
        </div>
      </Col>
      <Col span={12}>
        <div style={{ paddingLeft: 4 }}>
          <Input
            id="inputGivenName"
            maxLength={100}
            placeholder="名"
            value={name.givenName}
            onChange={onChangeGivenName}
            type="text"
            size="large"
            disabled={disabled}
            readOnly={readOnly}
            status={error ? 'error' : null}
          />
        </div>
      </Col>
    </Row>
  )
}

export const validateName = (rule, value) => {
  if (value) {
    const { familyName, givenName } = value
    if (!familyName) {
      return Promise.reject('名前(姓)を入力してください')
    }
    if (!givenName) {
      return Promise.reject('名前(名)を入力してください')
    }
    if ((familyName && !familyName.match(/^[^　]+$/)) || (givenName && !givenName.match(/^[^　]+$/))) {
      return Promise.reject('全角スペースは使用できません')
    }
  }
  return Promise.resolve()
}

export default NameInput
